class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest("form"),
      inputs: this.querySelectorAll("input[type='radio']")
    };

    elements.inputs.forEach((element) => {
      element.addEventListener("change", () => {
        const variant = get_variant();

        if (!variant || !variant.id) return;

        elements.form.querySelector("[name=id]").value = variant.id;

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);

        this.onVariantChange(variant.id);
      });
    });

    function get_variant() {
      const selected_options = get_selected_options(elements.inputs);
      const variant_title = selected_options.join(" / ").trim();
      const variant = get_variant_by_title(variant_title) || get_variant_by_options(selected_options);

      return variant;
    }

    function get_selected_options(form_elements) {
      return Array.from(form_elements)
        .filter(el => el.checked)
        .map(el => el.value);
    }

    function get_variant_by_title(title) {
      let selected_variant = null;

      Theme.Liquid.product.variants.forEach((variant) => {
        if (title == variant.title) {
          selected_variant = variant;
        }
      });

      return selected_variant;
    }

    function get_variant_by_options(selected_options) {
      let selected_variant = null;

      Theme.Liquid.product.variants.forEach((variant) => {
        const variant_options = variant.title.split(" / ");
        const is_match = selected_options.every((option) => variant_options.includes(option));

        if (is_match) {
          selected_variant = variant;
        }
      });

      return selected_variant;
    }
  }
  onVariantChange(variantId) {
    const sectionWrapper = document.querySelector(".product-info");
    if (!sectionWrapper) return;
    const sectionId = sectionWrapper.dataset.sectionId;
    this.fetchSection(sectionId, variantId);
  }

  fetchSection(sectionId, variantId) {
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newSection = doc.querySelector(`.product-info[data-section-id='${sectionId}']`);
        const current = document.querySelector(`.product-info[data-section-id='${sectionId}']`);
        if (newSection && current) current.replaceWith(newSection);
      });
  }
}

customElements.define("product-form-variants", ProductFormVariants)
